// 所有枚举



// 站点类型
export const SiteTypeEnum = Object.freeze({
  //省平台（默认）
  SPT: {
    type: 'spt',
    code: '001',
  },
  // 珠海
  ZHUHAI: {
    type: 'zhuhai',
    code: '002',
  },
  // 肇庆
  ZHAOQING: {
    type: 'zhaoqing',
    code: '003',
  },

});


//需要实现一个方法，传入type，返回枚举对象
export function getSiteValByType(type) {

  if(!type){
    //如果为空，默认返回省平台
    return SiteTypeEnum.SPT;
  }

  let site = Object.values(SiteTypeEnum).find(item => item.type === type);
  if(!site){
    //如果为空，默认返回省平台
    return SiteTypeEnum.SPT;
  }
  return  site;
}


// 作为 Vue 插件导出（实现 install 逻辑）
export default {
  install(app) {
    // 将枚举挂载到全局属性 $enumVals
    app.config.globalProperties.$enumVals = {
      SiteTypeEnum,
      getSiteValByType,
    };
  },
  // 同时暴露这些功能作为插件的静态属性
  SiteTypeEnum,
  getSiteValByType
};
